import { UI_ArticleMedia } from 'ui/components/2-molecules/Article/ArticleMedia/ArticleMedia';

interface Props {
	content: {
		properties: {
			image: Content.Image;
			caption: string;
			altText: string;
		};
	};
	settings: {
		properties: {
			disableCropping: boolean;
		};
	};
}

export const ArticleMedia = ({ content, settings }: Props) => {
	const { caption, image, altText } = content?.properties ?? {};
	const { disableCropping } = settings?.properties ?? {};
	return image?.url ? (
		<UI_ArticleMedia
			caption={caption}
			image={{
				url: image?.url,
				focalPoint: image?.focalPoint,
				extension: image?.extension,
			}}
			altText={altText}
			disableCropping={disableCropping}
		/>
	) : null;
};
